import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { AnnouncementDetails_announcement } from "@saleor/announcements/types/AnnouncementDetails";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import FormSpacer from "@saleor/components/FormSpacer";
import { sectionNames } from "@saleor/intl";
import { maybe, splitDateTime } from "@saleor/misc";
import { convertFromRaw, RawDraftContentState } from "draft-js";
import React from "react";
import { useIntl } from "react-intl";
import Moment from "react-moment";

export interface AnnouncementFormData {
  content: RawDraftContentState;
  image: string;
  title: string;
  startDate: string;
  endDate: string;
}

export interface AnnouncementDetailsPageProps {
  data: AnnouncementDetails_announcement;
  onBack: () => void;
  disabled: boolean;
}

const useStyles = makeStyles(
  {
    image: {
      height: "50%",
      objectFit: "contain",
      userSelect: "none",
      width: "50%"
    },
    imageHolder: {
      display: "flex",
      justifyContent: "center",
      width: "100%"
    },
    title: {
      fontSize: 20,
      fontWeight: "bold"
    },
    titleRow: {
      display: "flex",
      justifyContent: "space-between",
      margin: 20
    }
  },
  { name: "AnnouncementDetailsViewPage" }
);

const AnnouncementDetailsPage: React.FC<AnnouncementDetailsPageProps> = props => {
  const { onBack, data } = props;
  const intl = useIntl();
  const classes = useStyles("");

  const initialForm: AnnouncementFormData = {
    content: data && JSON.parse(data.content),
    endDate:
      data && data.endDate
        ? splitDateTime(maybe(() => data.endDate, "")).date
        : null,
    image: maybe(() => data.image.url, null),
    startDate:
      data && data.startDate
        ? splitDateTime(maybe(() => data.startDate, "")).date
        : null,
    title: maybe(() => data.title, "")
  };

  const initialDescription = maybe<RawDraftContentState>(() =>
    JSON.parse(data.content)
  );

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.announcements)}
      </AppHeader>
      <Card>
        <div className={classes.titleRow}>
          <span className={classes.title}>{initialForm.title}</span>
          <span>
            <Moment format="MM/DD/YYYY">{initialForm.startDate}</Moment>
          </span>
        </div>
        <CardContent>
          {initialForm.image && (
            <div className={classes.imageHolder}>
              <img className={classes.image} src={initialForm.image} />
            </div>
          )}
          <FormSpacer />
          <p>
            {initialDescription &&
              convertFromRaw(initialDescription).getPlainText()}
          </p>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AnnouncementDetailsPage;
